<template>
  <gj-modal
      size="1200_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      notFooterPadding
      @cancel="cancel"
      @confirm="confirm">
    <template #header>添加监控ASIN</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="80px"
          >
        <el-form-item
            label="监控人"
            prop="monitor"
            :rules="[
              { required: true, message: '请选择监控人', trigger: ['change', 'blur'] }
            ]"
        >
          <gj-select
              v-model="form.monitor"
              :options="active ? activeUserOptions : userOptions"
              multiple
              width="100%"
              @change="selectMonitor"
              :clearable="false">
          </gj-select>
        </el-form-item>
        <el-form-item
            label="排除店铺"
            prop="excludeName"
            :rules="[
              { trigger: ['change', 'blur'] }
            ]"
            >
          <gj-textarea
              v-model="form.excludeName"
              width="600px"
              placeholder="请输入排除店铺的Seller ID（默认排除对接到系统的店铺）；如有多个，请使用换行隔开；请勿输入其他字符或空行"
              :autosize="{ minRows: 4 }"
          >
          </gj-textarea>
        </el-form-item>

        <el-form-item
            label="监控ASIN"
            prop="productPicker"
            class="gj-table-item"
        >
          <app-product-picker
              ref="productPicker"
              :market-id="marketId"
              :form="form.productPickerForm"
              title="ASIN"
          ></app-product-picker>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "@/minxins";
import {mapGetters} from "vuex";
import {USER_GET_ACTIVE_USER_OPTIONS, USER_GET_USER_OPTIONS} from "@/store/action-types";
import AppProductPicker from "@/views/modules/tool/monitor/add/common/product-picker";
import {
  AdBidTypeEnum,
  AdCampaignEnum, AdGroupEnum, AdKeywordEnum,
  AdNegKeywordEnum
} from "@/views/modules/ad/common/enum";
import {addFollow} from "@/api/tool";
import {defaultVal, isMeaningful} from "@/utils/common";
import {convertToDate} from "@/utils/date.util";

export default {
  name: "app-add-sp-ad-campaign",
  mixins: [modalMixIn],
  components: {
    AppProductPicker
  },
  props: {
    marketId: {

    },
  },
  data() {
    return {
      form: {
        monitor: [],
        excludeName: '',
        productPickerForm: {
          items: []
        },
        defaultBid: 0.75,
        keywordPickerForm: {
          items: [],
          matchType: AdKeywordEnum.SP.matchType.EXACT,
          matchTypes: [
            AdKeywordEnum.SP.matchType.EXACT,
            AdKeywordEnum.SP.matchType.PHASE,
            AdKeywordEnum.SP.matchType.BROAD
          ],
          bid: null,
        },
        targetType: AdGroupEnum.SP.targetingType.KEYWORD,
        bidPickerForm: {
          bidType: AdBidTypeEnum.default,
          defaultBid: 0.75,
          items: [],
        },
        productTargetPickerForm: {
          items: [],
          bid: null
        }
      },
      AdNegKeywordEnum: AdNegKeywordEnum,
      active: false
    }
  },
  computed: {
    ...mapGetters({
      userOptions: 'userOptions',
      activeUserOptions: 'activeUserOptions'
    }),
    keywordTarget() {
      return this.form.targetType === AdGroupEnum.SP.targetingType.KEYWORD;
    },
    productTarget() {
      return this.form.targetType === AdGroupEnum.SP.targetingType.PRODUCT;
    },
    pickedAsinList() {
      // return (this.form.productPickerForm.items || []).map(e => e.asin || e.countryCode);
      let offerMonitorAsins = [];
      offerMonitorAsins = (this.form.productPickerForm.items || []).map(e => {
        let newItem = {};
        newItem.asin = e.asin;
        newItem.countryCode = e.countryCode;
        newItem.marketId = e.marketId;
        return newItem;
      })
      return offerMonitorAsins;
    },
  },
  created() {
    if (this.active) {
      if (this._.isEmpty(this.activeUserOptions)) {
        this.$store.dispatch(USER_GET_ACTIVE_USER_OPTIONS);
      }
    } else {
      if (this._.isEmpty(this.userOptions)) {
        this.$store.dispatch(USER_GET_USER_OPTIONS);
      }
    }
  },
  methods: {
    selectMonitor(row){
    },
    //添加监控ASIN
    confirm() {
      // 验证子form
      let formValid = !['base', 'bidStrategyPicker', 'productPicker', 'keywordBidPicker', 'bidPicker']
          .map(e => this.$refs[e])
          .filter(ref => isMeaningful(ref))
          .some(ref => !ref.formValidate());
      // 验证当前form
      this.$refs.form.validate((valid) => {
        formValid = formValid && valid;
      });
      if (formValid) {
        const params = {
          offerMonitorAsins: this.pickedAsinList,
          exceptSellerIds: this.form.excludeName ? this.form.excludeName.split(/[\s\n]/) : [],
          offerUserIds: this.form.monitor || [],
        };
        this.confirmLoading = true;
        addFollow(params)
            .then(() => {
              this.$gjDestroy();
              this.$emit('created');
            })
            .complete(() => this.confirmLoading = false);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common/common";
</style>

